import React from 'react';

function ContactInfoCard({ icon, text }) {
    return (
        <div className='contactCard'>
            {icon}
            <p>{text}</p>
        </div>
    );
}

export default ContactInfoCard;
